import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './feature-badge.component.scss';
var FeatureBadge = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureBadge, _super);
    function FeatureBadge(element) {
        return _super.call(this, element) || this;
    }
    FeatureBadge.prototype.init = function () { };
    FeatureBadge.prototype.bindEvents = function () { };
    return FeatureBadge;
}(Base));
export { FeatureBadge };



//////////////////
// WEBPACK FOOTER
// ./components/feature-badge/feature-badge.component.ts
// module id = 278
// module chunks = 0